import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore/lite';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  projectId: process.env.FIREBASE_PROJECT_ID,
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);

// App Check, so Firestore reads pass when enforcement is on. This site shares
// its Firebase web app with the admin dashboard (web/), so it uses the same
// reCAPTCHA Enterprise key; that key must list this site's domains. In local
// dev, a debug token stands in (register it in the Firebase console).
if (process.env.NODE_ENV !== 'production') {
  // @ts-expect-error Firebase uses this global to enable debug tokens in dev
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

const recaptchaSiteKey = process.env.FIREBASE_RECAPTCHA_ENTERPRISE_SITE_KEY;
if (recaptchaSiteKey) {
  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(recaptchaSiteKey),
    isTokenAutoRefreshEnabled: true,
  });
} else {
  console.warn('FIREBASE_RECAPTCHA_ENTERPRISE_SITE_KEY is not set; App Check is off.');
}

export const auth = getAuth(app);

/** Read-only use: the hosted Terms and Privacy Policy (`legal_documents`). */
export const db = getFirestore(app);

/** The delete-account page's callables (functions/src/deleteAccount.ts); App Check above is required. */
export const functions = getFunctions(app);
